module.exports = __webpack_public_path__ + "img/ปลาทรายแดง.881284db.jpg";